import { OrderItem } from '~/api/data/response/types';

const getOrderItemUnitValue = (orderItem: OrderItem) => {
  // orderItem.variant.amount is 0 when 'any amount' is chosen
  return orderItem.variant.amount || orderItem.amount || 0;
};

export default getOrderItemUnitValue;
